import { render, staticRenderFns } from "./template_group.vue?vue&type=template&id=1f62d489&scoped=true&"
import script from "./template_group.vue?vue&type=script&lang=js&"
export * from "./template_group.vue?vue&type=script&lang=js&"
import style0 from "./template_group.vue?vue&type=style&index=0&id=1f62d489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62d489",
  null
  
)

export default component.exports